import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { completeAccountEmailChange } from "@/api/auth";
import { clearConsoleBffCsrfToken } from "@/api/client";
import { Button } from "@/components/ui/button";
import { AuthShell } from "@/components/layout/AuthShell";

export function AccountEmailVerifyPage() {
  const navigate = useNavigate();
  const initialized = useRef(false);
  const [token, setToken] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;
    const presented = new URLSearchParams(globalThis.location.hash.slice(1)).get("token");
    globalThis.history.replaceState(null, "", globalThis.location.pathname);
    if (presented) setToken(presented);
    else setFailed(true);
  }, []);

  const complete = async () => {
    if (!token) return;
    setBusy(true);
    try {
      await completeAccountEmailChange(token);
      setToken(null);
      clearConsoleBffCsrfToken();
      navigate("/login", { replace: true });
    } catch {
      setToken(null);
      setFailed(true);
      setBusy(false);
    }
  };

  return (
    <AuthShell
      title={failed ? "確認リンクを利用できません" : "アカウントメールを変更"}
      description={failed ? "リンクは使用済み、期限切れ、または現在のセッションでは利用できません。" : "確定すると、現在を含むすべてのセッションが終了します。"}
    >
      {failed
        ? <Link className="text-primary underline" to="/console/account/security">アカウント設定へ戻る</Link>
        : <Button className="w-full" disabled={busy || !token} onClick={() => void complete()}>新しいアカウントメールを確定</Button>}
    </AuthShell>
  );
}
